import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navigate = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="bg-[#990000]">
      <div className="flex flex-row h-16 items-center gap-8 px-10">
        <div className="relative flex items-center w-screen">
          <div className="flex items-center w-full">
            <Link
              to="/"
              aria-label="AIDL"
              title="AIDL"
              className="no-underline w-full"
            >
              <span className="ml-2 text-xl font-bold tracking-wide text-gray-100 uppercase">
                AI-DL Virtual Labs
              </span>
            </Link>
            <div className="flex flex-row justify-end items-center space-x-2">
              <ul className="flex justify-end items-center hidden space-x-8 w-max lg:flex">
                <li>
                  <Link
                    to="/"
                    aria-label="Home"
                    title="Home"
                    className="no-underline font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    aria-label="About Us"
                    title="About Us"
                    className="no-underline font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                  >
                    About Us
                  </Link>
                </li>

                <li>
                  <Link
                    to="/experiments"
                    aria-label="Experiment"
                    title="Experiment"
                    className="no-underline font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                  >
                    Experiments
                  </Link>
                </li>

                <li>
                  <Link
                    to="/team"
                    aria-label="Team"
                    title="Team"
                    className="no-underline font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                  >
                    Team
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    aria-label="contact us"
                    title="contact us"
                    className="no-underline font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>

              <div className="flex flex-row justify-end lg:hidden">
                <button
                  aria-label="Open Menu"
                  title="Open Menu"
                  className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
                  onClick={() => setIsMenuOpen(true)}
                >
                  <svg className="w-5 text-gray-800" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                    />
                    <path
                      fill="currentColor"
                      d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                    />
                    <path
                      fill="currentColor"
                      d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                    />
                  </svg>
                </button>
                {isMenuOpen && (
                  <div className="absolute top-0 left-0 w-full z-10">
                    <div className="p-5 bg-[#fafad5] border-1 border-black rounded shadow-sm">
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <Link
                            to="/"
                            aria-label="AIDL"
                            title="AIDL"
                            className="no-underline inline-flex items-center"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <span className=" ml-2 text-xl font-bold tracking-wide text-[#990000] uppercase">
                              AI-DL Virtual Labs
                            </span>
                          </Link>
                        </div>
                        <div>
                          <button
                            aria-label="Close Menu"
                            title="Close Menu"
                            className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-white focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <svg
                              className="w-5 text-gray-600"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <nav>
                        <ul className="space-y-4">
                          <li>
                            <Link
                              to="/"
                              aria-label="Home"
                              title="Home"
                              className="no-underline font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              Home
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/experiments"
                              aria-label="Experiment"
                              title="Experiments"
                              className="no-underline font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              Experiments
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about"
                              aria-label="About Us"
                              title="About Us"
                              className="no-underline font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              About Us
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/team"
                              aria-label="Team"
                              title="Team"
                              className="no-underline font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              Team
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/contact"
                              aria-label="Contact us"
                              title="Contact us"
                              className="no-underline font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              Contact Us
                            </Link>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigate;

// import React from 'react'

// const Navigate = () => {
//   return (
//     <header aria-label="Navbar" className="bg-[#990000]">
//   <div
//     className="mx-auto flex h-16 max-w-screen-xl items-center gap-8 px-4 sm:px-6 lg:px-8"
//   >
//     <div className="flex flex-1 items-center justify-end md:justify-between">
//     <a className="block text-white no-unerline" href="home">
//       AI-DL Virtual Labs
//     </a>
//     </div>

//     <div className="flex flex-1 items-center justify-end md:justify-between">
//       <nav aria-label="Site Nav" className="hidden md:block">
//         <ul className="flex items-center gap-6 text-sm">
//           <li>
//             <a className="m-2 text-white transition hover:text-white/75" href="/">
//               Home
//             </a>
//           </li>

//           <li>
//             <a className="text-white transition hover:text-white/75" href="about">
//               About Us
//             </a>
//           </li>

//           <li>
//             <a className="text-white transition hover:text-white/75" href="team">
//               Team
//             </a>
//           </li>

//           <li>
//             <a className="text-white transition hover:text-white/75" href="experiments">
//               Experiments
//             </a>
//           </li>

//           <li>
//             <a className="text-white transition hover:text-white/75" href="contact">
//               Contact Us
//             </a>
//           </li>

//         </ul>
//       </nav>

//         <button
//           className="block rounded bg-gray-100 p-2.5 text-gray-600 transition hover:text-gray-600/75 md:hidden"
//         >
//           <span className="sr-only">Toggle menu</span>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-5 w-5"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             stroke-width="2"
//           >
//             <path
//               stroke-linecap="round"
//               stroke-linejoin="round"
//               d="M4 6h16M4 12h16M4 18h16"
//             />
//           </svg>
//         </button>
//       </div>
//     </div>

// </header>

//   );
// }

// export default Navigate
